import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { useFabDrag } from './hooks/useFabDrag'
import { useAiChatBotEnabled } from '../connector/scrivito/useAiChatBotEnabled'
import { useAiChatBotStore } from '../core/store/useAiChatBotStore'
import { theme } from '@/Atomic/assets/theme'
import { Icon } from '@/Atomic/Atoms/Icon'

const FloatingButton = styled.button`
  position: fixed;
  bottom: ${theme.space['2xl']};
  right: ${theme.space['2xl']};
  /* Bootstrap fixed-element tier — sits above page content, below modals */
  z-index: 1050;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  background-color: ${theme.colors.background.default};
  border: 1px solid ${theme.colors.border.stroke};
  border-radius: 50% 50% 50% 8px;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    background-color: ${theme.colors.background.subtle};
    box-shadow:
      rgba(50, 50, 93, 0.3) 0px 4px 10px -2px,
      rgba(0, 0, 0, 0.35) 0px 2px 5px -2px;
  }

  &:active {
    background-color: ${theme.colors.background.active};
  }
`

export function AiChatBotFab() {
  const { t } = useTranslation()
  const enabled = useAiChatBotEnabled()
  const isOpen = useAiChatBotStore((s) => s.isOpen)
  const { open } = useAiChatBotStore.getState()
  const fabRef = useFabDrag()

  if (!enabled || isOpen) return null

  return (
    <FloatingButton
      ref={fabRef}
      type="button"
      onClick={() => open()}
      aria-label={t('components.aiChatBot.openAssistant')}
    >
      <Icon icon="bubble-chat-ai" color="strong" />
    </FloatingButton>
  )
}
